import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Sessions = () => {
    return (
        <React.Fragment>
            <SEO title="Sessions | ICSI 2023" />
            <Header />
            <Breadcrumb
                image="images/banner/banner.jpg"
                title="Sessions"
                content="The Conference"
                contentTwo="Sessions"
                linkage="/"
            />

            {/* <HomeAbout /> */}
            <EmptyTwo>
                <div className="entry-content2">
                    <h2>
                        The Scheduled Timetable of ALL Presentations for ICSI&apos;2023
                    </h2>
                    <div className="space-50"></div>

                    <div className="notice"></div>

                    {/* begin here */}
                    <div className="main-table"><div className="title-center"><h4>Day I &nbsp;&nbsp;&nbsp;July 15th</h4></div>
<table className="sessions">
<tr> <th> Session Time </th><th>Athena Hall</th>
<th>Poseidon Hall</th>
<th>Gaia Hall</th>
<th>Online Room 1</th>
<th>Online Room 2</th>
 </tr><tr> <th>10:20-10:40</th> <td> <p className="table-id"> No. #2887</p>
 <p className="table-title">Balancing Measurement Eciency, Test Diversity and Security for Item Selection in On-the-Fly Assembled Multistage Adaptive Testing via a Multi-objective Evolutionary Algorithm</p>
 <p className="table-authors">Xiaoshu Xiang, Ling Wu, Haiping Ma and Xingyi Zhang</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>10:40-11:00</th> <td> <p className="table-id"> No. #587</p>
 <p className="table-title">On the Privacy Issue of Evolutionary Biparty Multiobjective Optimization</p>
 <p className="table-authors">Zeneng She, Wenjian Luo, Yatong Chang, Zhen Song and Yuhui Shi</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>13:20-13:40</th> <td> <p className="table-id"> No. #3578</p>
 <p className="table-title">An Atomic Retrospective Learning Bare Bone Particle Swarm Optimization</p>
 <p className="table-authors">Guoyuan Zhou, Jia Guo, Ke Yan, Guoao Zhou and Bowen Li</p></td>
<td> <p className="table-id"> No. #5513</p>
 <p className="table-title">Overview of Complex Intelligent System Reliability Technology</p>
 <p className="table-authors">Zhaoyang Zeng, Wensheng Peng and Jiao Li</p></td>
<td> <p className="table-id"> No. #1114</p>
 <p className="table-title">Exploration of Underwater Environments with a Swarm of Heterogeneous Surface Robots</p>
 <p className="table-authors">Yifeng He, Kanzhong Yao, Barry Lennox and Farshad Arvin</p></td>
<td> <p className="table-id"> No. #3145</p>
 <p className="table-title">Swarm Multi-agent Trapping Multi-target Control with Obstacle Avoidance</p>
 <p className="table-authors">Chenyang Li, Guanjie Jiang, Yonghui Yang and Xuebo Chen</p></td>
<td> <p className="table-id"> No. #1162</p>
 <p className="table-title">Small Aerial Target Detection Algorithm Based on Improved YOLOv5</p>
 <p className="table-authors">Tianle Yang, Jinlong Chen and Minghao Yang</p></td>
</tr><tr> <th>13:40-14:00</th> <td> <p className="table-id"> No. #5374</p>
 <p className="table-title">PSO with Local Search using Personal Best Solution for Environments with Small Number of Particles</p>
 <p className="table-authors">Yuji Sato, Yuma Yamashita and Jia Guo</p></td>
<td> <p className="table-id"> No. #6442</p>
 <p className="table-title">The Swarm Hierarchical Control System</p>
 <p className="table-authors">Eugene Larkin, Tatiana Akimenko and Aleksey Bogomolov</p></td>
<td> <p className="table-id"> No. #2481</p>
 <p className="table-title">Multiple Unmanned Aerial Vehicles Path Planning Based on Collaborative Differential Evolution</p>
 <p className="table-authors">Yao Lu and Xiangyin Zhang</p></td>
<td> <p className="table-id"> No. #3239</p>
 <p className="table-title">Research on UAV Dynamic Target Tracking with Multi-sensor Position Feedback</p>
 <p className="table-authors">Peng Liu, Junchao Wei, Hao Wang, Chunjun He, Jianxia Zhang, Haiyue Li, Ziyuan Liu and Baorui Jiang</p></td>
<td> <p className="table-id"> No. #2808</p>
 <p className="table-title">Abnormal Traffic Detection based on a Fusion BiGRU Neural Network</p>
 <p className="table-authors">Lin Jiang, Dahua Zhang, Yayun Zhu and Xiaojuan Zhang</p></td>
</tr><tr> <th>14:00-14:20</th> <td> <p className="table-id"> No. #6692</p>
 <p className="table-title">Hybrid Algorithm Based on Phasor Particle Swarm Optimization and Bacterial Foraging Optimization(submitted to Special Session 1)</p>
 <p className="table-authors">Xiaole Liu, Chenhan Wu, Peilin Chen and Yongjin Wang</p></td>
<td> <p className="table-id"> No. #1456</p>
 <p className="table-title">Analysis of SIR Compartmental Model Results with Different Update Strategies</p>
 <p className="table-authors">Mijat Kustudic, Maja Gulan, Junrui Lu and Ben Niu</p></td>
<td> <p className="table-id"> No. #4007</p>
 <p className="table-title">A Novel Data Association Method for Multi-target Tracking Based on IACA</p>
 <p className="table-authors">Yi Di, Guoyuan Zhou, Ziyi Tan, Ruiheng Li and Zheng Wang</p></td>
<td> <p className="table-id"> No. #4958</p>
 <p className="table-title">A Blockchain-Based Service-Oriented Framework to Enable Cooperation of Swarm Robots</p>
 <p className="table-authors">Wei-Po Lee, Jhih-Yuan Huang, Chung-Yu Huang and Jhih-Yi Li</p></td>
<td> <p className="table-id"> No. #3493</p>
 <p className="table-title">Intrusion Detection Method Based on Complementary Adversarial Generation Network</p>
 <p className="table-authors">Lixiang Li, Yuxuan Liu and Haipeng Peng</p></td>
</tr><tr> <th>14:20-14:40</th> <td> <p className="table-id"> No. #9042</p>
 <p className="table-title">Hybrid Algorithm Based on Phasor Particle Swarm Optimization and Firefly Algorithm (submitted to Special Session 1)</p>
 <p className="table-authors">Peilin Chen, Chenhan Wu, Xiaole Liu and Yongjin Wang</p></td>
<td> <p className="table-id"> No. #3752</p>
 <p className="table-title">Asynchronous Federated Learning Framework Based on Dynamic Selective Transmission</p>
 <p className="table-authors">Ruizhuo Zhang, Wenjian Luo, Yongkang Luo and Shaocong Xue</p></td>
<td> <p className="table-id"> No. #6835</p>
 <p className="table-title">Design and Analysis of VLC-OCC-CDMA Rake System with Multiple Sources</p>
 <p className="table-authors">Qiu Yang, Si Yujuan, Yu Xiaoyu, Yang Dong, Chen Yuexin and Yang Wenke</p></td>
<td> <p className="table-id"> No. #1077</p>
 <p className="table-title">Integrating Reinforcement Learning and Optimization Task: Evaluating an agent to dynamically select PSO communication topology</p>
 <p className="table-authors">Rodrigo Cesar Lira da Silva, Mariana Macedo, Hugo Siqueira and Carmelo J. A. Bastos Filho</p></td>
<td> <p className="table-id"> No. #7338</p>
 <p className="table-title">Analysis of the Impact of Mathematics Courses on Professional Courses in Science and Engineering Majors</p>
 <p className="table-authors">Zhihong Sun, Zhigang Zhang and Danling Wang</p></td>
</tr><tr> <th>14:40-15:00</th> <td> <p className="table-id"> No. #8645</p>
 <p className="table-title">A Dual-strategy Contest Harmony Search Algorithm Based on Population State for the System Reliability-Redundancy Allocation Problems</p>
 <p className="table-authors">Siqi Liang, Chang He and Haibin Ouyang</p></td>
<td> <p className="table-id"> No. #8156</p>
 <p className="table-title">Noise-tolerant Hardware-aware Pruning for Deep Neural Networks</p>
 <p className="table-authors">Shun Lu, Cheng Chen, Kunlong Zhang, Yang Zheng, Zheng Hu, Wenjing Hong, Guiying Li and Xin Yao</p></td>
<td> <p className="table-id"> No. #8622</p>
 <p className="table-title">MACT: Multi-agent Collision Avoidance with Continuous Transition Reinforcement Learning via Mixup</p>
 <p className="table-authors">Pu Feng, Xin Yu, Junkang Liang, Wenjun Wu and Yongkai Tian</p></td>
<td> <p className="table-id"> No. #6274</p>
 <p className="table-title">Collective Behavior for Swarm Robots with Distributed Learning</p>
 <p className="table-authors">Junqiao Zhang, Qiang Qu and Xue-Bo Chen</p></td>
<td> <p className="table-id"> No. #922</p>
 <p className="table-title">Sensitivity of Clustering Algorithms to Sparseness of One Correlation Network</p>
 <p className="table-authors">Anastasiia Timofeeva and Natalya Gorbacheva</p></td>
</tr><tr> <th>15:20-15:40</th> <td> <p className="table-id"> No. #1217</p>
 <p className="table-title">A Modified Gaining-Sharing Knowledge Algorithm Based on Dual-Population and Multi-Operators for Unconstrained Optimization</p>
 <p className="table-authors">Haoran Ma, Jiahao Zhang, Wenhong Wei, Wanyou Cheng and Qunfeng Liu</p></td>
<td> <p className="table-id"> No. #307</p>
 <p className="table-title">Beam-GBAS for Multidimensional Knapsack Problems</p>
 <p className="table-authors">Jianjun Cao, Chumei Gu, Baowei Wang, Zhen Yuan, Nianfeng Weng and Yuxin Xu</p></td>
<td> <p className="table-id"> No. #6986</p>
 <p className="table-title">Reinforced Vision-and-Language Navigation Based on Historical BERT</p>
 <p className="table-authors">Zixuan Zhang, Shuhan Qi, Zihao Zhou, Jiajia Zhang, Hao Yuan, Xuan Wang, Lei Wang and Jing Xiao</p></td>
<td> <p className="table-id"> No. #2611</p>
 <p className="table-title">Secure Access Method of Power Internet of things based on Zero Trust Architecture</p>
 <p className="table-authors">Zhihua Wang, Minghui Jin, Lin Jiang, Chenjia Feng, Jingyi Cao and Yun Zhang</p></td>
<td>  </td>
</tr><tr> <th>15:40-16:00</th> <td> <p className="table-id"> No. #1537</p>
 <p className="table-title">Adaptive Artificial Bee Colony Algorithm Considering Colony’s Memory</p>
 <p className="table-authors">Jiacheng Li, Masato Noto and Yang Zhang</p></td>
<td> <p className="table-id"> No. #1611</p>
 <p className="table-title">Brain Storm Optimization Integrated with Cooperative Coevolution for Large-Scale Constrained Optimization</p>
 <p className="table-authors">Yuetong Sun, Peilan Xu, Ziyu Zhang, Tao Zhu and Wenjian Luo</p></td>
<td> <p className="table-id"> No. #7680</p>
 <p className="table-title">Monte Carlo Tree Search with Adaptive Estimation for DAG Scheduling</p>
 <p className="table-authors">Alexander Allahverdyan, Anastasia Zhadan, Ivan Kondratov, Vikenty Mikheev, Ovanes Petrosian, Aleksei Romanovskii and Vitaliy Kharin</p></td>
<td> <p className="table-id"> No. #8018</p>
 <p className="table-title">A Repetitive Grouping Max-Min Ant System for Multi-Depot Vehicle Routing Problem with Time Window</p>
 <p className="table-authors">Wanfeng Chen, Ruochen Liu, Qi Guo and Mengyi Niu</p></td>
<td> <p className="table-id"> No. #827</p>
 <p className="table-title">Meta-heuristics for Portfolio Optimization: Part II - Empirical Analysis</p>
 <p className="table-authors">Kyle Erwin and Andries Engelbrecht</p></td>
</tr><tr> <th>16:00-16:20</th> <td> <p className="table-id"> No. #2838</p>
 <p className="table-title">Multi-Objective Baby Search Algorithm</p>
 <p className="table-authors">Yi Liu, Gengsong Li, Wei Qin, Xiang Li, Kun Liu, Qiang Wang and Qibin Zheng</p></td>
<td> <p className="table-id"> No. #2902</p>
 <p className="table-title">Neural Architecture Search Based on Improved Brain Storm Optimization Algorithm</p>
 <p className="table-authors">Xiaojie An, Lianbo Ma, Yuee Zhou, Nan Li, Tiejun Xing, Yingyou Wen, Chang Liu and Haibo Shi</p></td>
<td> <p className="table-id"> No. #8585</p>
 <p className="table-title">Resource Allocation in Heterogeneous Network with Supervised GNNs</p>
 <p className="table-authors">Qiushi Sun, Yuyi Zhang, Haitao Wu and Ovanes Petrosian</p></td>
<td> <p className="table-id"> No. #463</p>
 <p className="table-title">A Two-stage Evolutionary Algorithm with Repair Strategy for Heat Component-Constrained Layout Optimization</p>
 <p className="table-authors">Ke Shi, Yu Zhang, Xinyue Li and Wang Hu</p></td>
<td> <p className="table-id"> No. #1967</p>
 <p className="table-title">Application of APSO-BP Neural Network Algorithm in Stock Price Prediction</p>
 <p className="table-authors">Ying Sun, Jingbo He and Yuelin Gao</p></td>
</tr><tr> <th>16:20-16:40</th> <td> <p className="table-id"> No. #5069</p>
 <p className="table-title">A Memetic Algorithm for Solving the Robust Influence Problem on Directed Networks</p>
 <p className="table-authors">Zhaoxi Ou, Shuai Wang and Shun Cai</p></td>
<td> <p className="table-id"> No. #5672</p>
 <p className="table-title">A WGAN-based Generative Strategy in Evolutionary Multitasking for Multi-objective Optimization</p>
 <p className="table-authors">Tianwei Zhou, Xizhang Yao, Guanghui Yue and Ben Niu</p></td>
<td> <p className="table-id"> No. #5702</p>
 <p className="table-title">Satellite downlink scheduling under breakpoint resume mode</p>
 <p className="table-authors">Zhongxiang Chang, Zhou Zhongbao and Shi Cheng</p></td>
<td>  </td>
<td> <p className="table-id"> No. #8072</p>
 <p className="table-title">Meta-heuristics for Portfolio Optimization: Part I — Review of Meta-heuristics</p>
 <p className="table-authors">Kyle Erwin and Andries Engelbrecht</p></td>
</tr><tr> <th>16:40-17:00</th> <td> <p className="table-id"> No. #193</p>
 <p className="table-title">The Research in Credit Risk of Micro and Small Companies with Linear Regression Model</p>
 <p className="table-authors">Yan Ying and Li Bo</p></td>
<td> <p className="table-id"> No. #145</p>
 <p className="table-title">Intelligent System Reliability Modeling Methods</p>
 <p className="table-authors">Jiao Li, Wensheng Peng, Zhaoyang Zeng, Chenxi Li and Haochen Wang</p></td>
<td> <p className="table-id"> No. #6899</p>
 <p className="table-title">On the Complete Area Coverage Problem of Painting Robots</p>
 <p className="table-authors">Gene Eu Jan, Kevin Fung, Chaomin Luo Luo and Hui-Ching Hsieh</p></td>
<td> <p className="table-id"> No. #4501</p>
 <p className="table-title">Competitive Learning and Dynamic Genetic Algorithms for Robust Layout Designs Under Uncertainties</p>
 <p className="table-authors">Srisatja Vitayasak and Pupong Pongcharoen</p></td>
<td> <p className="table-id"> No. #5549</p>
 <p className="table-title">Quad-Criteria Task Scheduling in Multicores Based on NSGAIII</p>
 <p className="table-authors">Jiaxuan Wang, Zheng Tan and Bo Yuan</p></td>
</tr><tr> <th>17:00-17:20</th> <td> <p className="table-id"> No. #2360</p>
 <p className="table-title">Hierarchical Node Representation Learning for Stock Prediction</p>
 <p className="table-authors">Zhihan Yue and Ying Tan</p></td>
<td> <p className="table-id"> No. #625</p>
 <p className="table-title">A Fabric Defect Detection Model Based on Feature Extraction of Weak Sample Scene</p>
 <p className="table-authors">Maosen Wang, Mengtian Wang, Jun Liu, Shaozhang Niu, Wen Zhang and Jiaqi Zhao</p></td>
<td>  </td>
<td> <p className="table-id"> No. #8701</p>
 <p className="table-title">An Improved NSGA-II for Solving Reentrant Flexible Assembly Job Shop Scheduling Problem</p>
 <p className="table-authors">Xiuli Wu, Yaqi Zhang and Kunhai Zhao</p></td>
<td> <p className="table-id"> No. #4602</p>
 <p className="table-title">Reachability Map-based Motion Planning for Robotic Excavation</p>
 <p className="table-authors">Fan Li, Xiaotian Li, Feng Chi and Yong Wang</p></td>
</tr></table>
<div className="title-center"><h4>Day II &nbsp;&nbsp;&nbsp;July 16th</h4></div>
<table className="sessions">
<tr> <th> Session Time </th><th>Athena Hall</th>
<th>Poseidon Hall</th>
<th>Gaia Hall</th>
<th>Online Room 1</th>
<th>Online Room 2</th>
 </tr><tr> <th>9:00-9:20</th> <td> <p className="table-id"> No. #1548</p>
 <p className="table-title">A bilevel genetic algorithm for global optimization problems</p>
 <p className="table-authors">Ziru Lun, Zhanyu Ye and Qunfeng Liu</p></td>
<td> <p className="table-id"> No. #778</p>
 <p className="table-title">A Large-Scale Multi-Ojbective Brain Strom Optimization Algorithm Based on Direction Vectors and Variance Analysis</p>
 <p className="table-authors">Yang Liu, Tiejun Xing, Yuee Zhou, Nan Li, Lianbo Ma, Yingyou Wen, Chang Liu and Haibo Shi</p></td>
<td>  </td>
<td> <p className="table-id"> No. #8383</p>
 <p className="table-title">Pyrorank: a Nature Inspired Algorithm to Promoting Diversity in Recommender Systems</p>
 <p className="table-authors">Anasse Bari, Nicholas Greenquist and Doruk Kilitcioglu</p></td>
<td> <p className="table-id"> No. #8107</p>
 <p className="table-title">Dual-Populatuion Differential Evolution L-NTADE for ICSI-OC&apos;2023 Competition</p>
 <p className="table-authors">Vladimir Stanovov and Eugene Semenkin</p></td>
</tr><tr> <th>9:20-9:40</th> <td> <p className="table-id"> No. #2740</p>
 <p className="table-title">Genetic Algorithm for Product Design Optimization: An Industrial Case Study of Halo Setting for Jewelry Design</p>
 <p className="table-authors">Somlak Kielarova and Prapasson Pradujphongphet</p></td>
<td> <p className="table-id"> No. #969</p>
 <p className="table-title">Differential Evolution Using Special Sorting for Multimodal Multi-objective Optimization with Local Pareto Sets</p>
 <p className="table-authors">Li Yan, Yiran Li, Boyang Qu, Baihao Qiao, Hongxin Duan and Shunge Guo</p></td>
<td>  </td>
<td> <p className="table-id"> No. #2115</p>
 <p className="table-title">Research on Location Selection of General Merchandise Store Based on Machine Learning</p>
 <p className="table-authors">Lin Boyu, Li Feipeng, Feng Jiqiang and Xu Shengbing</p></td>
<td> <p className="table-id"> No. #2701</p>
 <p className="table-title">Swarm Intelligence Algorithms and Applications: An Experimental Survey</p>
 <p className="table-authors">Anasse Bari, Robin Zhao, Jahnavi Swetha Pothineni and Deepti Saravanan</p></td>
</tr><tr> <th>9:40-10:00</th> <td> <p className="table-id"> No. #939</p>
 <p className="table-title">An Improved Seagull Algorithm for Numerical Optimization Problem</p>
 <p className="table-authors">Waqas Haider Bangyal, Rabia Shakir, Najeeb Ur Rehman, Adnan Ashraf and Jamil Ahmad</p></td>
<td> <p className="table-id"> No. #3859</p>
 <p className="table-title">Modified Brain Storm Optimization Algorithm for Solving Multimodal Multiobjective Optimization Problems</p>
 <p className="table-authors">Yue Liu, Shi Cheng, Xueping Wang, Yuyuan Shan and Hui Lu</p></td>
<td>  </td>
<td> <p className="table-id"> No. #4594</p>
 <p className="table-title">CF-PMSS: Collaborative Filtering Based on Preference Model and Sparrow Search</p>
 <p className="table-authors">Wei Song and Shuya Li</p></td>
<td> <p className="table-id"> No. #2005</p>
 <p className="table-title">Particle Swarm Optimizer without Communications among Particles</p>
 <p className="table-authors">Junqi Zhang, Xurui Huang, Huan Liu and Mengchu Zhou</p></td>
</tr><tr> <th>10:20-10:40</th> <td> <p className="table-id"> No. #5267</p>
 <p className="table-title">Multi-label Ensemble Defense Scheme Based on Negative Correlation</p>
 <p className="table-authors">Hongwei Zhang, Wenjian Luo, Zhijian Chen and Qi Zhou</p></td>
<td> <p className="table-id"> No. #4063</p>
 <p className="table-title">CCGSK-PSO: Constrained Multi-objective Particle Swarm Optimization Algorithm Based on Co-evolution and Gaining-sharing Knowledge</p>
 <p className="table-authors">Liyan Qiao and Sibo Hou</p></td>
<td>  </td>
<td> <p className="table-id"> No. #6945</p>
 <p className="table-title">Hybrid Artificial Ecosystem-based Optimization Algorithm Solves Photovoltaic Models Parameter Identification Problem</p>
 <p className="table-authors">Xiaoqiu Yu</p></td>
<td>  </td>
</tr><tr> <th>10:40-11:00</th> <td> <p className="table-id"> No. #7229</p>
 <p className="table-title">Secondary Pulmonary Tuberculosis Lesions Detection Based on Improved YOLOv5 Networks</p>
 <p className="table-authors">Haojie Xie, Mingli Lu and Jing Liu</p></td>
<td> <p className="table-id"> No. #4894</p>
 <p className="table-title">Dynamic Multi-Modal Multi-Objective Evolutionary Optimization Algorithm Based on Decomposition</p>
 <p className="table-authors">Biao Xu, Yang Chen, Ke Li, Zhun Fan, Dunwei Gong and Lin Bao</p></td>
<td>  </td>
<td> <p className="table-id"> No. #5292</p>
 <p className="table-title">An Improved Fire Hawks Optimizer for Function Optimization</p>
 <p className="table-authors">Adnan Ashraf, Aliza Anwaar, Waqas Haider Bangyal, Rabia Shakir, Najeeb Ur Rehman and Zhao Qingjie</p></td>
<td>  </td>
</tr><tr> <th>11:00-11:20</th> <td> <p className="table-id"> No. #9430</p>
 <p className="table-title">EEG-Based Subject-Independent Depression Detection Using Dynamic Convolution and Feature Adaptation</p>
 <p className="table-authors">Wanqing Jiang, Nuo Su, Tianxu Pan, Yifan Miao, Xueyu Lv, Tianzi Jiang and Nianming Zuo</p></td>
<td> <p className="table-id"> No. #6725</p>
 <p className="table-title">A Diversified Multi-objective Particle Swarm Optimization Algorithm for Unsupervised Band Selection of Hyperspectral Images</p>
 <p className="table-authors">Yuze Zhang, Lingjie Li, Zhijiao Xiao, Qiuzhen Lin and Zhong Ming</p></td>
<td>  </td>
<td> <p className="table-id"> No. #6392</p>
 <p className="table-title">Hierarchical Heterogeneous Ant Colony Optimization Based Approach to Optimize File Similarity Searches Using ssDeep</p>
 <p className="table-authors">Sreelaja N.K and Sreeja N.K</p></td>
<td>  </td>
</tr><tr> <th>11:20-11:40</th> <td>  </td>
<td>  </td>
<td>  </td>
<td> <p className="table-id"> No. #6466</p>
 <p className="table-title">Multi-Modal Honey Bee Foraging Optimizer for Weapon Target Assignment Problem</p>
 <p className="table-authors">Beena S Lawrence and Vinod Chandra S S</p></td>
<td>  </td>
</tr><tr> <th>11:40-12:00</th> <td>  </td>
<td>  </td>
<td>  </td>
<td> <p className="table-id"> No. #9874</p>
 <p className="table-title">Improved Ant Colony Optimization Based Binary Search for Point Pattern Matching for Efficient Image Matching</p>
 <p className="table-authors">Sreeja N.K and Sreelaja N.K</p></td>
<td>  </td>
</tr></table>
</div>




                    {/* end here */}
                </div>
            </EmptyTwo>
            {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    );
};

export default Sessions;
